import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MasterService } from '../../services/master-mom.service'
import { UserService } from '../../services/user.service';
import { ToastrUtilsService } from 'src/app/services/toastr-utils.service';
import { RSAHelper } from '../../services/RSAHelper';

// import { TranslateService } from "@ngx-translate/core";
import { DOCUMENT } from "@angular/common";






@Component({
  selector: 'app-top-header',
  templateUrl: './top-header.component.html',
  styleUrls: ['./top-header.component.css'],
  providers: [ToastrUtilsService]
})

export class TopHeaderComponent implements OnInit {


 
  //above changes for languags
  public filled = false; allapps: any = [];
  public firstname: string = "";
  public active_language_code: string = "en";
  public selected_lang: string = "en";
  imgdynamicurl = '';
  constructor(private toaster: ToastrUtilsService, public RSAHelper: RSAHelper, private userService: UserService, private masterservice: MasterService
    // ,private translate: TranslateService
    , @Inject(DOCUMENT) private document: Document) {
    console.log('Header constructor called');
    // translate.setDefaultLang('en');
    // this.active_language_code='en';
    this.imgdynamicurl = environment.imgdynamicurl;
  }
  changeLangage(lang: string) {
    let htmlTag = this.document.getElementsByTagName(
      "html"
    )[0] as HTMLHtmlElement;
    htmlTag.dir = lang === "ar" ? "rtl" : "ltr";
    // this.translate.setDefaultLang(lang);
    // this.translate.use(lang);
    this.changeCssFile(lang);
    
    window.localStorage.setItem('selected_lang', lang);

    //window.location.reload();  

    if (lang=='ar')
    {

     // document.body.setAttribute('dir','rtl');      
      console.log(111111111111111111111111111111)
      document.querySelectorAll('.side-menu').forEach(function(element) {
        (element as HTMLElement).style.padding = '60px 0px 0px 0px';
      });
      
      
      document.querySelectorAll('.nav.toggle').forEach(function(element) {
        (element as HTMLElement).style.right="20px"
      });
      
      document.querySelectorAll('.scrollcontainer').forEach(function(element) {
        (element as HTMLElement).style.paddingRight="6%"
      });
      
      
      const elements = document.querySelectorAll('.logos a');
      const indexToSetPadding = 2;

      if (indexToSetPadding >= 0 && indexToSetPadding < elements.length) {
        const element = elements[indexToSetPadding] as HTMLElement;
        element.style.textAlign="left" ;
      }


      const elements_ = document.querySelectorAll('.logos a');
      const indexToSetPadding_ =0;

      if (indexToSetPadding_ >= 0 && indexToSetPadding_ < elements_.length) {
        const element = elements_[indexToSetPadding_] as HTMLElement;
        element.style.textAlign="right" ;
      }


      //document.querySelectorAll('.mr-auto')[0].style.marginRight="5%";
      document.querySelectorAll('.col-md-1').forEach(function(element) {
        (element as HTMLElement).style.cssFloat = "left";
      });  
      

      document.getElementById('navHeader').classList.remove("mr-auto");
      document.getElementById('navHeader').style.marginLeft="46%";


      document.querySelectorAll('.right_col').forEach(function(element) {
        (element as HTMLElement).style.marginLeft = "0px";
      });  
      

      document.getElementById('user-dropdown').setAttribute( 'style', 'display: inline-flex;float:left' );
     
      document.querySelector('.col-md-11 marquee').setAttribute( 'direction', 'right' );


      document.querySelectorAll('.main_container .top_nav').forEach(function(element) {
        (element as HTMLElement).style.marginLeft="0px";
      });  

      document.querySelectorAll('app-top-header > .nav').forEach(function(element) {
        (element as HTMLElement).style.marginRight="54px"
      });  
     
      document.querySelector('.main_menu i').setAttribute( 'style', 'float:right  !important' );
      //
      document.querySelector('.rounded-circle').setAttribute( 'style', 'width: 38px !important ;   height: 38px;    margin-left: 12px; ' );
      //document.querySelector('.rounded-circle').setAttribute( 'style', ' height: 38px;' );

      document.querySelector('.navbar-right').setAttribute( 'style','margin: 0px  !important' );


      var check =document.querySelectorAll('.main_menu i');
      for (var i = 0, len = check.length; i < len; i++) 
      {
        check[i].setAttribute( 'style','float: right !important;     padding-right: 0px !important;' );
      }
      
      document.querySelectorAll('.modal-header .close')[0].setAttribute( 'style','margin: 0px;' );
      
      document.getElementById('user-dropdown').style.position = 'left';
      //this.reload_check=1;
      //=""
      //window.location.reload();


    }
    else{
      document.getElementById('navHeader').style.marginLeft="7%";
      var scrollcontainer_pr='';
      document.querySelectorAll('.scrollcontainer').forEach(function(element) 
      {
        scrollcontainer_pr=(element as HTMLElement).style.paddingRight;
      });      
      console.log(scrollcontainer_pr)

      if(scrollcontainer_pr=='')
      {
        document.querySelectorAll('.scrollcontainer').forEach(function(element) {
          (element as HTMLElement).style.paddingLeft="1%"
        });
      }
      else
      {
        document.querySelectorAll('.scrollcontainer').forEach(function(element) {
        (element as HTMLElement).style.paddingLeft="7%"
        });
      }
      

      document.querySelectorAll('.navbar-right').forEach(function(element) {
        (element as HTMLElement).style.marginRight="10px"
      });

    }
    
    this.active_language_code=lang



  }
  
  changeCssFile(lang: string) {
    let headTag = this.document.getElementsByTagName(
      "head"
    )[0] as HTMLHeadElement;
    let existingLink = this.document.getElementById(
      "langCss"
    ) as HTMLLinkElement;
  
    let bundleName = lang === "ar" ? "/mw/assets/arabicStyle.css" : "/mw/assets/englishStyle.css";
  
    if (existingLink) {
      existingLink.href = bundleName;
    } else {
      let newLink = this.document.createElement("link");
      newLink.rel = "stylesheet";
      newLink.type = "text/css";
      newLink.id = "langCss";
      newLink.href = bundleName;
      headTag.appendChild(newLink);
    }
  }
  




  title = 'ngx-skeleton-loader-demo';
  animation = 'pulse';
  contentLoaded = false;
  user: any = []; useremail: string = "";
  intervalId;
  keyword = "applnname";

  ngOnInit() {
    setTimeout(() => {
      this.contentLoaded = true;
    }, 2000);

    this.intervalId = setInterval(() => {
      this.animation = this.animation === 'pulse' ? 'progress-dark' : 'pulse';
    }, 5000);
 
    const user = this.userService.getUserInfo();
    if (!environment.production) {
      this.useremail = environment.testEmail;
      this.RefreshSecurityToken(this.useremail);
    }
    else {
      this.useremail = user.email;
      this.firstname = user.sub;
      this.RefreshSecurityToken(this.useremail);

    }

    this.selected_lang=window.localStorage.getItem('selected_lang');
    if (this.selected_lang!='')
    {
       this.changeLangage(this.selected_lang)
    }

  }

  RefreshSecurityToken(userEmail) {
    try {

      const objTxnData = {
        "email": userEmail,
        "isExternal": environment.isExternal
      };
      let encryptedioparam = this.RSAHelper.encryptWithPublicKey(JSON.stringify(objTxnData));
      this.masterservice.refreshToken(JSON.stringify(encryptedioparam)).subscribe((result: any) => {
        console.log(result);
        sessionStorage.removeItem('iammwtoken');
        sessionStorage.setItem('iammwtoken', result.token);

        this.LoadApplication(this.useremail);


      },
        (error) => {


        }
      ).add(() => {

      });
    }
    catch (err) { console.log(err); }
  }

  LoadApplication(useremail: string) {
    try {

      const objTxnData = {
        "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(useremail)),
        "isExternal": this.RSAHelper.encryptWithPublicKey(JSON.stringify(environment.isExternal))
      };

      this.masterservice.allApplns(JSON.stringify(objTxnData)).subscribe((result: any) => {

        var resultdata = result.data;
        for (let i = 0; i < resultdata.length; i++) {
          let appid = resultdata[i].appid;
          //if (this.popupdata1.filter(item => item.appid === appid) == 0)
          for (let j = 0; j < resultdata[i].applicationInfo.length; j++) {
            this.allapps.push(resultdata[i].applicationInfo[j]);
          }
        }
      },
        (error) => {
          this.toaster.ErrorCustomMessage('There was an unexpected error.');
        }
      ).add(() => {
      });
    }
    catch (err) { console.log(err); }
  }

  loaduser() {
    //this.user = this.userService.getUserProfileInfo();
    /*if(this.user!=null)
    {
      this.useremail=JSON.parse(this.user).firstname;
    }*/

  }

  LogOut(){
    try {
        console.log('idle time out');

        this.userService.logout();
        sessionStorage.removeItem('iammwtoken');
        // window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';
        try {

            console.log('idle time out step 2');
            window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';

            setTimeout(function () {
                console.log('idle time out step 3');
                window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';
            }, 100);


        }
        catch (err) {
            console.log(err);
            console.log('idle time out step 2');
            window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';

            setTimeout(function () {
                console.log('idle time out step 3');
                window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';
            }, 100);

        }

    }
    catch (err) {
        console.log(err);
       // setTimeout(function () {
            console.log('idle time out step 4');
            window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';
       // }, 100);

        setTimeout(function () {
            console.log('idle time out step 4');
            window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';
        }, 600);
    }
}

  selectEvent(item) {
    //window.open()
    //console.log(item);
    //Removed for launch to be enabled again
    window.open(item.applnurl);
  }

  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onFocused(e) {
    // do something when input is focused      
  }

  ngOnDestroy() {
  }
}